import axios from 'axios'
import * as Cookies from 'js-cookie'

const HTTP = axios.create({
  headers: {
    'X-localization': 'id' || localStorage.getItem('locale'),
    'Access-Control-Allow-Origin' : '*'
    // 'Accept': 'application/json'
    // "Content-Type": "application/x-www-form-urlencoded"
  },
})

// before a request is made start the nprogress
HTTP.interceptors.request.use((config) => {
  return config
})

// before a response is returned stop nprogress
HTTP.interceptors.response.use(
  (response) => {
    // success interceptor
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 404
    ) {
      return response
    } else {
      // auto logout
      // eslint-disable-next-line no-lonely-if
      if (response && response.status === 401) {
        Cookies.remove('x-access-token')
        Cookies.remove('vuex')

        // push only if not in login page
        // if (Router.currentRoute.fullPath !== '/') {
        //   Router.push('/')
        // }
      }
    }

    const error = {}
    error.response = response
    return Promise.reject(error)
  },
  (error) => {
    // error interceptor
    const data = error.response
    // auto logout
    if (data && data.status === 401) {
      Cookies.remove('x-access-token')
      Cookies.remove('vuex')
      // push only if not in login page

      // if (Router.currentRoute.fullPath !== '/') {
      //   Router.push('/')
      // }
    }
    return Promise.reject(error)
  }
)

export {
  HTTP
}
